import fromResult from './fromResult';

const setLocalStorage = (json) => localStorage
    .setItem('secret', json.secret);

export default (json) => fromResult(json, setLocalStorage);
